import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M4 17a2 2 0 1 0 4 0a2 2 0 1 0 -4 0","key":"svg-1"}],["path",{"d":"M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1","key":"svg-2"}],["path",{"d":"M10 4l-2 4h3l-2 4","key":"svg-3"}]]

const IconScooterElectric = createReactComponent('outline', 'scooter-electric', 'ScooterElectric', __iconNode);

export default IconScooterElectric;